function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_65_6)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.8273 26.9249C30.6004 27.7206 30.4756 28.9025 29.5474 29.5652C29.1549 29.8463 28.6596 30.0003 28.1481 30C27.5211 30 26.8992 29.7702 26.4671 29.325L17.2081 19.7531L7.95228 29.2745C7.5197 29.7195 6.89817 29.9495 6.27132 29.9495C5.75982 29.9497 5.26452 29.7958 4.872 29.5147C3.94368 28.852 3.81858 27.6701 4.59214 26.8744L14.3607 16.8256L4.5905 6.82728C3.81715 6.03158 3.94211 4.84975 4.87064 4.18705C5.79759 3.5226 7.1764 3.62947 7.95091 4.42693L17.2081 13.9464L26.464 4.42494C27.2365 3.62924 28.6159 3.52143 29.5443 4.18506C30.4726 4.84775 30.5977 6.02959 29.8241 6.82529L20.0556 16.8741L29.8273 26.9249Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_65_6"
}, /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 30,
  fill: "white"
})));

function SvgWhiteCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCancel);
export default __webpack_public_path__ + "static/media/whiteCancel.72642091.svg";
export { ForwardRef as ReactComponent };